import {
  type QueryObserverOptions,
  useQuery,
  type UseQueryResult
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { failureFlagsQueryKeys } from 'queries/failure-flags/query-keys'
import { fetchFailureFlagsExperimentsActive } from 'queries/failure-flags/query-utils'
import {
  isPaginatedQueryParams,
  type PaginatedQueryParams
} from 'queries/queries-utils'

import type { AxiosError } from 'axios'
import type { FailureFlagsExperimentsActivePagedResponse } from 'types/api/failure-flags/experiments/active'
import type { FailureFlagExperiment } from 'types/api/failure-flags/failure-flags'

type QueryOptions = QueryObserverOptions<
  FailureFlagsExperimentsActivePagedResponse,
  AxiosError,
  FailureFlagExperiment[]
>

export function useGetFailureFlagsExperimentsActiveWithPagination(
  options?: QueryOptions
): UseQueryResult<FailureFlagExperiment[], AxiosError>

export function useGetFailureFlagsExperimentsActiveWithPagination(
  queryParams?: PaginatedQueryParams,
  options?: QueryOptions
): UseQueryResult<FailureFlagExperiment[], AxiosError>

export function useGetFailureFlagsExperimentsActiveWithPagination(
  params = {},
  options = {}
) {
  const { currentTeamId } = useAuth()

  const queryOptions = isPaginatedQueryParams(params) ? options : params
  const queryParams = isPaginatedQueryParams(params) ? params : undefined

  return useQuery<
    FailureFlagsExperimentsActivePagedResponse,
    AxiosError,
    FailureFlagExperiment[],
    ReturnType<typeof failureFlagsQueryKeys.getExperimentsActive>
  >({
    ...queryOptions,
    queryKey: failureFlagsQueryKeys.getExperimentsActive({
      teamId: currentTeamId,
      ...queryParams
    }),
    queryFn: fetchFailureFlagsExperimentsActive
  })
}
